<!-- <a v-if="isSubscribed" :href="ctaLink">Email Preferences</a> -->
<!-- <router-link v-else :to="{hash: ctaLink}">Stay Informed</router-link> -->
<!-- <a v-if="!isSubscribed" :href="ctaLink" target="_self">Stay Informed</a> -->

<template>
  <a v-if="!isSubscribed" href="#join" target="_self">Join Our Community</a>
</template>

<script setup>
import {inject} from "vue";
const isSubscribed = inject("isSubscribed");
</script>

<style scoped>
a {
  /* font-size: 1.73rem; */
  white-space: nowrap;
  font-weight: bold;
  color: white;
  background-color: var(--brand-color);
  padding: 0.6rem 2.3rem;
  border-radius: 17px; /* Example value to increase rounded corners */
}
.narrow a {
  padding: 0.6rem 0.8rem;
}
/* Button-like styling for anchor tags */
a {
  text-align: center; /* Center the text inside the button */
  text-decoration: none; /* Removes underline from links */
  border: none; /* Removes border */
  cursor: pointer; /* Changes the cursor to indicate clickable items */
}

/* Hover effect */
:is(a:hover, a:focus) {
  color: white;
  background-color: var(--brand-hover-color); /* Darkens */
  text-decoration: none; /* Ensures text remains not underlined on hover */
  outline: none; /* Removes outline to keep the design clean */
}
/* Active (click) effect */
a:active {
  background-color: var(--brand-hover-color); /* darken */
}
.isSubscribed {
  background-color: red;
}
</style>
